import React from 'react';
import { connect } from 'redux-zero/react';
import { injectIntl } from 'react-intl';

import OurMissionPageService from './our-mission.service.js';
import { actions } from '../../shared/store.js';
import NotImplemented from '../../components/not-implemented/page-not-implemented.js';
import ScrollToTop from '../../shared/utils.js';
import Seo from '../../infrastructure/seo.js';

import './our-mission.scss';

const Description = ({ data }) => (
	<section className="introduction">
		<div className="container container-fluid">
			<div className="row">
				<div className="col-xs-12 col-md-4 top-xs start-xs">
					{data.title && <h2 className="title">{data.title}</h2>}
				</div>
				<div className="col-xs-12 col-md-8 top-xs start-xs">
					{data.description && (
						<p className="description">{data.description}</p>
					)}
				</div>
			</div>
		</div>
	</section>
);

class OurMissionPage extends React.Component {
	static prefetchData = async language => OurMissionPageService.getOurMissionData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		ScrollToTop();
		if (this.props.ourMission.length === 0) {
			this.fetchData();
		} else {
			this.props.setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		ScrollToTop();
		if (prevProps.language.value !== this.props.language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		this.props.setLoading(true);
		OurMissionPage.prefetchData(this.props.language.value)
			.then((res) => {
				this.props.setOurMission(res);
				this.props.setLoading(false);
			})
			.catch((error) => {
				this.setState({ hasError: true });
				this.props.setLoading(false);
				console.log(error);
			});
	}

	render() {
		const { ourMission, intl: { formatMessage }, addresses, phones, generalData } = this.props;
		const { hasError } = this.state;

		const regex = /(<([^>]+)>)/ig;

		if (hasError || !ourMission) {
			return <NotImplemented title="Our values" />;
		}

		return (
			<div className="our-mission-page">
				<Seo
					title={formatMessage({ id: 'navigation.about.ourMission' })}
					description={(ourMission && ourMission.description) ? ourMission.description.replace(regex, '') : formatMessage({ id: 'navigation.about.ourMission' })}
					image={(ourMission && ourMission.image) && `${process.env.REACT_APP_API_ENDPOINT}${ourMission.image.path}`}
					microdata={`{
									"@context": "https://schema.org",
									"@graph": [
										{
											"@type": "AboutPage",
											"name": "${ourMission && ourMission.title}",
											"description": "${(ourMission && ourMission.description) && ourMission.description.replace(regex, '')}",
											"image": "${(ourMission && ourMission.image) && `${process.env.REACT_APP_API_ENDPOINT}${ourMission.image.path}`}"
										},
										{
											"@type": "WebApplication",
											"name": "Inocrowd",
											"url": "${process.env.REACT_APP_WEBSITE_ENDPOINT}",
											"applicationCategory": "BusinessApplication",
											"operatingSystem": "Windows, Linux, OSX, iOS, Android",
											"sameAs": [
												"${process.env.REACT_APP_PLATFORM_ENDPOINT}",
												"https://www.facebook.com/InoCrowd/",
												"https://www.linkedin.com/company/inocrowd",
												"https://twitter.com/InoCrowd",
												"https://www.instagram.com/inocrowd",
												"https://www.youtube.com/channel/UC8JotJA9Txz_6NQXWuEwdvQ"
											],
											"provider": {
												"@type": "Organization",
												"name": "Inocrowd",
												${addresses.length > 0 && `
													"address":  "${addresses[0].description.replace(/\n/g, ' ')}",
												`}
												${phones.length > 0 && `
													"contactPoint": {
														"@type": "ContactPoint",
														"telephone": "${phones[0].phoneNumber}",
														"contactType": "customer service"
													},
													"telephone": "${phones[0].phoneNumber}",
												`}
												${generalData && generalData.logo ? `
													"logo": "${process.env.REACT_APP_API_ENDPOINT}${generalData.logo.path}"
												` : ''}
											}
										},
										{
											"@type": "BreadcrumbList",
											"itemListElement": [
												{
													"@type": "ListItem",
													"name": "Inocrowd",
													"position": 1,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}"
												},
												{
													"@type": "ListItem",
													"name": "${formatMessage({ id: 'navigation.about.ourMission' })}",
													"position": 2,
													"item": "${process.env.REACT_APP_WEBSITE_ENDPOINT}/about/our-mission"
												}
											]
										}
									]
								}`}
				/>
				<Description data={ourMission} />

				{ourMission.image && (
					<div
						className="image"
						style={{
							backgroundImage: `url('${process.env.REACT_APP_API_ENDPOINT
								+ ourMission.image.path}')`,
						}}
					/>
				)}
			</div>
		);
	}
}

const mapToProps = ({ language, ourMission, addresses, phones, generalData }) => ({
	language,
	ourMission,
	addresses,
	phones,
	generalData,
});

export default injectIntl(
	connect(
		mapToProps,
		actions,
	)(OurMissionPage),
);

export { OurMissionPage };
